import {mapGetters, mapActions, mapMutations} from 'vuex'

export default {
    computed: {
        ...mapGetters('users', [
            'user',
        ]),

        userLaboratory() {
            return this?.user?.laboratory
        },

        userLaboratoryId() {
            return this.userLaboratory?.id
        },

        userCountry() {
            return this?.user?.country
        },

    },

    methods: {
        ...mapMutations([
            'setGlobalLoading'
        ]),

        ...mapMutations('users', {
            setOneUser: 'setUser',
        }),

        ...mapActions('users', {
            getOneUser: 'getOne',
            updateUser: 'update',
            uploadUserAvatar: 'uploadAvatar',
            removeUserAvatar: 'removeAvatar'
        }),

    }
}
